import axios from 'axios'
import { ACATS_DOCUMENTS_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getDocuments = (accountNumber: string, documentTypes: string) => {
  return axios.get(
    ACATS_DOCUMENTS_API(accountNumber, documentTypes),
    WITH_CREDENTIALS_CONFIG
  )
}
